export const isMobileOrTablet = () => {
  const mobileData = navigator.userAgentData;
  let isDeviceMatch = false;
 
  if (mobileData && typeof mobileData.mobile === "boolean") {
    isDeviceMatch = mobileData.mobile;
  } else {
    const validDevice = navigator.userAgent || "";
    isDeviceMatch = /android|iphone|ipad|ipod|iemobile|windows phone|blackberry|webos/i.test(
      validDevice
    );
  }
 
  const isSmallScreen = window.innerWidth <= 1023;
 
  return isDeviceMatch && isSmallScreen;
};
 